import { OpensearchSearchRequestOpenSearchDataTypeEnum } from '@interfaces/models';
import { getCoreRowModel, useReactTable } from '@ui/components/data-table';
import { getCostCenterTopUpsHistory } from '@api/cost-centers';
import { getOpensearchTableConfig } from '@api/opensearch';
import { useAutoColumns } from '@shared/components';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';

export interface TopUpsHistoryFilters {
  dateFrom?: string;
  dateTo?: string;
}

export const useCostCenterTopUpsHistory = (filters?: TopUpsHistoryFilters) => {
  const { costCenterId } = useParams();

  const { data: columns, isLoading: isTableConfigLoading } = useQuery({
    queryKey: ['cost-center-top-ups-history-table-config'],
    queryFn: () =>
      getOpensearchTableConfig(OpensearchSearchRequestOpenSearchDataTypeEnum.ACCOUNT_TOP_UPS_SHORT),
    initialData: [],
  });

  // TODO: add filters when be ready
  const { data: history, isLoading: isHistoryLoading } = useQuery({
    queryKey: ['cost-center-top-ups-history', filters],
    queryFn: () =>
      getCostCenterTopUpsHistory(
        OpensearchSearchRequestOpenSearchDataTypeEnum.ACCOUNT_TOP_UPS_SHORT,
        costCenterId!,
        filters,
      ),
    enabled: !!costCenterId,
  });

  const { columnDefinitions } = useAutoColumns({ columns });

  const data = useMemo(() => {
    return history?.data || [];
  }, [history]);

  const table = useReactTable({
    data,
    columns: columnDefinitions,
    getRowId: (row) => row[0] as unknown as string,
    getCoreRowModel: getCoreRowModel(),
  });

  const isLoading = isTableConfigLoading || isHistoryLoading;

  const itemsLength = useMemo(() => data.length, [data]);

  return { table, isLoading, columnsLength: columnDefinitions.length, costCenterId, itemsLength };
};
